<div class="o-grid__item col-12">
  <span
    class="export-to-excel-button button-filter"
    (click)="onExportToExcel()">
    <span>{{ localizationConstants.BUTTON_EXPORT_TO_EXCEL | translate }}</span>
    <mat-icon
      svgIcon="file-excel"
      class="file-excel-icon"></mat-icon>
  </span>
</div>
